import { useId } from "react";

// The family mark: a disc with three arcs. The disc takes each company's color.
const Mark = ({ color = "var(--brand)", className }: { color?: string; className?: string }) => {
  const clip = `disc-${useId().replace(/[^a-zA-Z0-9]/g, "")}`;
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false" className={className}>
      <defs>
        <clipPath id={clip}>
          <circle cx="32" cy="32" r="30" />
        </clipPath>
      </defs>
      <circle cx="32" cy="32" r="30" style={{ fill: color }} />
      <g clipPath={`url(#${clip})`}>
        <path fill="#b8a9d8" d="M10 0C18 26 38 44 66 50V0Z" />
        <path fill="#9fb4ff" d="M24 0C30 18 44 31 66 35V0Z" />
        <path fill="#ffe9b3" d="M38 0C42 10 51 18 66 21V0Z" />
      </g>
    </svg>
  );
};

export default Mark;
